import classNames from 'classnames';
import React from 'react';
import { Typography } from "../../../typography/Typography.js";
import styles from "./DropdownCategory.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function DropdownCategory({
  label,
  children,
  small = false,
  ...props
}) {
  return /*#__PURE__*/_jsx("div", {
    className: classNames(styles.category, {
      [styles.small]: small
    }),
    ...props,
    children: /*#__PURE__*/_jsx(Typography, {
      margin: false,
      variant: "strong",
      children: children ?? label
    })
  });
}
// Sets a display name to be able to be parsed correctly
DropdownCategory.displayName = 'DropdownCategory';